import { SettingsPageLayout } from "../components/SettingsPageLayout";
import { useNavigate } from "react-router-dom";
import { ExpensesForm } from "./ExpensesForm";

/**
 * Expenses page - Mobile implementation
 * Full-screen form with swipe navigation (< 768px)
 */
function ExpensesMobile() {
  const navigate = useNavigate();

  return (
    <SettingsPageLayout
      title="Expenses"
      category="expenses"
      onBack={() => navigate("/settings")}
    >
      <ExpensesForm />
    </SettingsPageLayout>
  );
}

export default ExpensesMobile;
